import { Environment } from './environment.model';
import { deployedEnterpriseSso } from './deployed-enterprise-sso';

export const environment: Environment = {
  name: 'dev',
  production: false,
  apiUrl: 'https://api.ctat-dev.com',
  firebase: {
    apiKey: 'AIzaSyDyxA6QT5IvFsyBb3m8FppnOv-m7JH2Qis',
    authDomain: 'cog01kck333snjt0a3cj0tyfy190s.firebaseapp.com',
    projectId: 'cog01kck333snjt0a3cj0tyfy190s',
    messagingSenderId: '1017815501362',
    appId: '1:1017815501362:web:8d62a90bfe0ee99d1b0a2b',
    useEmulator: false,
    authMethods: {
      google: true,
      password: true,
    },
    enterpriseSso: deployedEnterpriseSso,
    storageBucket: 'cog01kck333snjt0a3cj0tyfy190s.firebasestorage.app',
  },
  constructionVendorEnabled: true,
};
